import { render } from "./Unimpersonate.vue?vue&type=template&id=2b2f2918"
import script from "./Unimpersonate.vue?vue&type=script&lang=js"
export * from "./Unimpersonate.vue?vue&type=script&lang=js"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__